import { AppConstants } from '@/helpers/app.constants';
import { AppConfigService } from '@/services/app-config.service';
import { BridgeService } from '@/services/bridge/bridge.service';
import { DictionaryCacheService } from '@/services/dictionary-cache.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);
  private dictCacheService = inject(DictionaryCacheService);
  private appConfig = inject(AppConfigService);

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (this.authenticationService.isUserConnected()) {
      this.dictCacheService.checkDictionaryVersion();
      BridgeService.isAuthenticated(true);
      // authorized
      return true;
    }

    this.authenticationService.currentUserSubject.next(null);
    // not logged in so redirect to login page with the return url
    const params = {};
    params[AppConstants.PARAM_RETURN_URL] = route.url.join('/');
    if (route.queryParams[AppConstants.PARAM_NO_ACCOUNT]) {
      params[AppConstants.PARAM_NO_ACCOUNT] = route.queryParams[AppConstants.PARAM_NO_ACCOUNT];
    }
    if (route.queryParams[AppConstants.PARAM_EMAIL]) {
      params[AppConstants.PARAM_EMAIL] = route.queryParams[AppConstants.PARAM_EMAIL];
    }
    if (route.queryParams[AppConstants.PARAM_CHANGE_USER]) {
      params[AppConstants.PARAM_CHANGE_USER] = route.queryParams[AppConstants.PARAM_CHANGE_USER];
    }
    if (route.queryParams[AppConstants.PARAM_IS_MOBILE_APP]) {
      params[AppConstants.PARAM_IS_MOBILE_APP] = route.queryParams[AppConstants.PARAM_IS_MOBILE_APP];
    }

    if (this.appConfig.isDemo()) {
      this.router.navigate(['/login/guest'], {
        queryParams: params,
      });
    } else {
      this.router.navigate(['/login'], {
        queryParams: params,
      });
    }
    BridgeService.isAuthenticated(false);
    return false;
  }
}
